<template>
  <header class="w-full mb-12">
    <div class="flex flex-col sm:flex-row items-center space-y-6 sm:space-y-0 sm:space-x-6">
      <!-- Анимированный логотип -->
      <div class="relative w-20 h-20 min-w-[5rem] min-h-[5rem] animate-logo-appear">
        <div class="absolute inset-0 bg-gradient-to-r from-emerald-500 to-green-500 rounded-full shadow-lg flex items-center justify-center">
          <img src="/profile2.jpg" alt="Profile Photo" class="rounded-full w-full h-full object-cover" />
        </div>
        <div class="absolute inset-0 rounded-full border-4 border-emerald-400 animate-ripple"></div>
        <div class="absolute inset-0 rounded-full border-4 border-emerald-300 animate-ripple" style="animation-delay: 1s"></div>
      </div>
      
      <!-- Анимированное имя -->
      <div class="text-center sm:text-left">
        <h1 class="text-3xl font-playfair font-bold tracking-wider text-gray-900 animate-name-reveal">
          <span class="name-container">
            <!-- KIRILL -->
            <span class="inline-block animate-letter mx-[0.5px]" style="animation-delay: 0.05s">K</span>
            <span class="inline-block animate-letter mx-[0.5px]" style="animation-delay: 0.10s">I</span>
            <span class="inline-block animate-letter mx-[0.5px]" style="animation-delay: 0.15s">R</span>
            <span class="inline-block animate-letter mx-[0.5px]" style="animation-delay: 0.20s">I</span>
            <span class="inline-block animate-letter mx-[0.5px]" style="animation-delay: 0.25s">L</span>
            <span class="inline-block animate-letter mx-[0.5px]" style="animation-delay: 0.30s">L</span>
            
            <!-- Пробел между именем и фамилией -->
            <span class="inline-block w-4"></span>
            
            <!-- LOGINOV -->
            <span class="inline-block animate-letter mx-[0.5px]" style="animation-delay: 0.35s">L</span>
            <span class="inline-block animate-letter mx-[0.5px]" style="animation-delay: 0.40s">O</span>
            <span class="inline-block animate-letter mx-[0.5px]" style="animation-delay: 0.45s">G</span>
            <span class="inline-block animate-letter mx-[0.5px]" style="animation-delay: 0.50s">I</span>
            <span class="inline-block animate-letter mx-[0.5px]" style="animation-delay: 0.55s">N</span>
            <span class="inline-block animate-letter mx-[0.5px]" style="animation-delay: 0.60s">O</span>
            <span class="inline-block animate-letter mx-[0.5px]" style="animation-delay: 0.65s">V</span>
          </span>
        </h1>
        <p class="text-emerald-600 font-inter mt-2 animate-fade-in-up text-lg" style="animation-delay: 0.7s">
          Full-Stack Python Developer <span class="mx-1 text-emerald-300">|</span> <span class="font-bold bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded">AI Engineer</span>
        </p>
        <p class="text-sm text-gray-600 font-inter mt-1 animate-fade-in-up" style="animation-delay: 0.8s">
          {{ currentDateTime }} UTC
        </p>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "AppHeader",
  props: {
    currentDateTime: {
      type: String,
      required: true
    }
  }
}
</script>